import { ApplicationAttachment } from './applicationAttachment';
import { Cip } from './eligibility';
import { Region } from './location';

export enum SponsorshipOpportunityStatus {
    CLOSED = 'CLOSED',
    DRAFT = 'DRAFT',
    IN_REVIEW = 'IN_REVIEW',
    PUBLISHED = 'PUBLISHED',
}

export enum SponsorshipOpportunityType {
    ATTRACT = 'ATTRACT',
    KEEP = 'KEEP',
    UPSKILL = 'UPSKILL',
}

export type MultipleCipEligibility = { allow_multiple: true; cip: null };
export type SingleCipEligibility = { allow_multiple: false; cip: Cip };

export interface SponsorshipOpportunity {
    id: string;
    cip_eligibility: SingleCipEligibility | MultipleCipEligibility;
    details_lines: string[];
    display_name: string;
    marketing_url?: string;
    opportunity_locations: Region[];
    opportunity_type: SponsorshipOpportunityType;
    optional_documents: ApplicationAttachment[];
    partner_name: string;
    required_documents: ApplicationAttachment[];
    requires_interview: boolean;
    url_slug: string;
}

export type StudentSponsorshipOpportunity = Pick<
    SponsorshipOpportunity,
    'id' | 'details_lines' | 'display_name' | 'marketing_url' | 'partner_name' | 'url_slug'
>;
